import React from 'react';

const Button = ({
  
  onClick,
  children,
  type = 'button',
  ...props
}) => {
  const roles = JSON.parse(sessionStorage.getItem("#roles") || "{}");
  const baseStyles =
    'py-[12px] px-4 text-[12px] rounded focus:outline-none focus:shadow-outline transition duration-300 font-ManropeSemibold';
  const variants = {
    primary: 'bg-primary hover:bg-primary text-blueColor transition-hover',
    secondary:
      'bg-blueColor hover:bg-primary_100 text-primary transition-hover',
  };
  const variant = roles === "student" ? "primary": roles === "teacher" ? "secondary":"tertiary"

  return (
    <button
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} flex items-center`}
      type={type}
      {...props}>
      {children}
    </button>
  );
};

export default Button;
